module.exports = __webpack_public_path__ + "static/media/BMODE_40_20.fc855752.jpg";